import React, { useState } from 'react';
import { List, TextField, FunctionField, SimpleList, Datagrid} from 'react-admin';
import { useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, Paper, Typography} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ScrollableTable from './components/ScrollableTable';
import moment from 'moment'
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import ParkingSearchSelector from './components/ParkingSearchSelector';
import CustomSearch from './components/CustomSearch';
import notify from './components/CustomUseNotify';
import config from "./config.json";
import { saveTokens } from './utils/saveTokens';
import { stringify } from 'query-string';
import Skeleton from '@material-ui/lab/Skeleton';
// import CustomDateTimePicker from './components/CustomDateTimePickerV2';
import CustomDateTimePickerV3 from './components/CustomDateTimePickerV3';

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    loaderContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
    chipCell: {
        textAlign: "center",
        padding: customTheme.spacing(1, 2),
        display: "inline-block",
        borderRadius: 50,
        minWidth: 100,
    },
    title: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    mainValue: {
        fontSize: 22,
        color: customTheme.palette.grey[900],
    },
    summaryBox: {
        padding: customTheme.spacing(3, 3),
    },
    twoColumnGrid: {
        padding: customTheme.spacing(1, 0, 2),
        display: "grid",
    },
    flexContainer: {
        display: 'flex',
        alignItems: "center",
    },
    summaryVehicleIcon: {
        width: 18,
        height: 18,
    },
    summaryBoxLabel1: {
        fontSize: "0.74em",
        color: customTheme.palette.grey[500],
        margin: customTheme.spacing(0, 2, 0, 1),
    },
    summaryBoxLabel2: {
        fontSize: 14,
        color: customTheme.palette.secondary.main,
    },
    paymentSummaryBoxLabel1: {
        fontSize: "0.74em",
        color: customTheme.palette.grey[500],
    },
    summaryBoxValue1: {
        fontSize: 13,
        color: customTheme.palette.grey[900],
    },
    tooltip: {
        fontSize: 13
    }
});

export const Settlements = (props) => {
    // const refresh = useRefresh();
    const classes = useStyles()
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const location = useLocation();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});
    const [summaryData, setSummaryData] = useState({})
    const [loadingSummary, setLoadingSummary] = useState(false);
    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));

    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["UTR Number", "Account Number", "IFSC"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "UTR Number");
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(null);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(null);
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

    const filter = { search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : ""};

    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if(use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    const fetchSummary = () => {
		setLoadingSummary(true);
		var params = {
			access_key_id: currentParking.id ? currentParking.id : undefined,
			parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
            access_key: currentParking.access_key ? currentParking.access_key : undefined,
            start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", 
            end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
		}

		fetch(`${config.HOST_NAME}/crm/settlementSummary?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
			},
		})
			.then(response => {
				saveTokens(response);
				return response.json();
			})
            .then(json => {
                if (json.success) setSummaryData(json.data);
                else notify(json.message, "warning");
            })
			.catch((e) => {
				console.log(e);
				notify("Something went wrong", "warning");
			})
			.finally(() => {
				setLoadingSummary(false);
			});
	};

    React.useEffect(() => {
      fetchSummary()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentParking, startDateTimeFilter, endDateTimeFilter])
    

    return (
        <div>
            <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
                {showFilter &&
                    <ParkingSearchSelector
                        value={currentParking}
                        onChange={onParkingChange}
                        clearable={true}
                        pathName={location.pathname}
                    />
                }

                {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                    <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                        <InputLabel>Zone Name</InputLabel>
                        <Select
                            value={currentParking.allZones ? "All" : currentParking.id}
                            onChange={onZoneChange}
                            label="Zone Name"
                            variant="outlined"
                        >
                            <MenuItem value="All">All</MenuItem>
                            {finalZones.map((zone, index) => (
                                <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
            <div className='customStyleForDataSearchDiv'>
                <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
                <CustomDateTimePickerV3 startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} hideTillDateFilter={true} />
            </div>

            <div className="vehicleSummaryContainer" style={{ marginTop: 15 }}>
                <SettlementSummaryCard
                    title1="Settled Amount"
                    value1={summaryData && summaryData.settled_amount}
                    title2="Amount To Be Settled"
                    value2={summaryData && summaryData.to_be_settled_amount}
                    loading={loadingSummary}
                />
            </div>

            <List {...props}
                style={{ marginTop: 20 }}
                empty={false}
                filter={filter}
                title="Settlements"
                bulkActionButtons={false}
                exporter={false}
                actions={false}
                pagination={<CustomPagination />} >

                {isSmallDevice ?
                    <SimpleList
                        primaryText={record => record && record.name}
                        secondaryText={record => (<div>
                            {record.UTRNUMBER && <div><span style={{ color: "#5a5a5a" }}>UTR No.: </span>{record.UTRNUMBER}</div>}
                            {record.ifsc && <div><span style={{ color: "#5a5a5a" }}>IFSC: </span>{record.ifsc}</div>}
                            {record.acc_no && <div><span style={{ color: "#5a5a5a" }}>Acc No.: </span>{record.acc_no}</div>}
                            {record.amount && <div><span style={{ color: "#5a5a5a" }}>Amount: </span>{record.amount}</div>}
                            {record.transaction_count && <div><span style={{ color: "#5a5a5a" }}>Count: </span>{record.transaction_count}</div>}
                            {record.settled_at && <div><span style={{ color: "#5a5a5a" }}>Settled At.: </span>{renderTime(record.settled_at)}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable}>
                        <TextField source="UTRNUMBER" label="UTR No." />
                        <TextField source="RESPONSE" label="Response" />
                        <FunctionField source="ifsc" label="IFSC" render={record => record && record["ifsc"] ? record["ifsc"] : '-'} />
                        <FunctionField source="acc_no" label="Acc No." render={record => record && record["acc_no"] ? record["acc_no"] : '-'} />
                        <FunctionField source="amount" label="Amount" render={record => record && record["amount"] ? `₹ ${record["amount"]}` : '-'} />
                        <TextField source="transaction_count" label="Transaction Count" />
                        <FunctionField source="settled_at" label="Settled At" render={record => record && record["settled_at"] ? renderTime(record["settled_at"]) : '-'} />
                        <FunctionField source="name" label="Name" render={record => record && record["name"] ? record["name"] : '-'} />
                    </Datagrid>
                }
            </List>
        </div>
    )
};


function SettlementSummaryCard({ title1, value1 = 0, title2, value2 = 0, loading }) {
    const classes = useStyles();
    return <>
        <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>
            <div>
                <div style={{ marginBottom: 10 }}>
                    <Typography className={classes.title}>{title1}</Typography>
                    {!loading ? <Typography className={classes.mainValue}>₹ {value1}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>

                <div style={{ marginBottom: 10 }}>
                    <Typography className={classes.title}>{title2}</Typography>
                    {!loading ? <Typography className={classes.mainValue}>₹ {value2}</Typography> : <Skeleton variant="text" height={36} width="34%" />}
                </div>
            </div>
        </Paper>
    </>
}